import { action, computed, makeObservable, observable } from 'mobx';
import { Query } from './types';

const DEFAULT_VALUE: Query = {
  _page: 1,
  _page_size: 0,
  _search: undefined,
  _limit: undefined,
  _offset: undefined,
};

export class Filter {
  @observable private _query: Query;

  constructor(value?: Partial<Query>) {
    this._query = { ...DEFAULT_VALUE, ...value };

    makeObservable(this);
  }

  @computed get pagination(): Pick<Query, '_page' | '_page_size'> {
    const { _page, _page_size } = this._query;

    return {
      _page,
      _page_size,
    };
  }

  @computed get param(): Partial<Omit<Query, '_page' | '_page_size'>> {
    const { _search, _limit, _offset } = this._query;
    const query: Partial<Omit<Query, '_page' | '_page_size'>> = {};

    if (_search !== undefined) query['_search'] = _search;

    if (_limit !== undefined) query['_limit'] = _limit;

    if (_offset !== undefined) query['_offset'] = _offset;

    return query;
  }

  @computed get query() {
    return { ...this._query };
  }

  @action mergeQuery(query: Partial<Query>) {
    this._query = { ...this._query, ...query };
  }

  @action setQuery(query: Query) {
    this._query = query;
  }
}
